export default "__VITE_ASSET__83bf9d24__"